// extracted by mini-css-extract-plugin
export default {"badge":"styles_badge__2zYBL","growth":"styles_growth__ro+uN","decline":"styles_decline__ti4rC","neutral":"styles_neutral__JwsVu","empty":"styles_empty__jb6i0"};